
export const underscoreCaseToNormalCase = (string: string) => string.replace(/[ \-_]/g, ' ');

export const capitaliseFirst = (string: string) => 
    string.length > 0 ?
        string[0].toUpperCase().concat(string.slice(1))
        : string
;
